export default __webpack_public_path__ + "static/media/lifestyleAnalysis2.19150858.png";